const TYPES = {
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
  INTERVAL: 'interval',
  TITLE: 'title',
  TITLE_CLEAR: 'title-clear',
};

export default TYPES;
